export const SHAPES = {
  jewelry: [
    'Round',
    'Princess',
    'Radiant',
    'Marquise',
    'Emerald',
    'Pear',
    'Asscher',
    'Cushion',
    'Oval',
    'Other',
  ],
  other: [], // we'll fill these from the server
};

export const SLIDERS_DATA = {
  clarity: ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1', 'I2', 'I3'],
  color: ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M-Z'],
};
